import { Chip, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { TbIcon } from 'components/Figma';
import { ChipLevels, getChipSxStylingForLevel } from 'styles/utils';
import { ReactNode } from 'react';
import { FilterableCountCard } from 'components/FilterableCountCard';

interface ProfitabilityStatusFilterCardProps {
  count: number;
  previousCount: number;
  titleId: string;
  dimensionLabelId?: string;
  selected?: boolean;
  onClick?: () => void;
  testId?: string;
}

export function ProfitabilityStatusFilterCard({
  count,
  previousCount,
  titleId,
  dimensionLabelId = undefined,
  selected = false,
  onClick = undefined,
  testId = undefined,
}: ProfitabilityStatusFilterCardProps) {
  const theme = useTheme();
  const delta = count - previousCount;

  let chipLevel: ChipLevels;
  let icon: ReactNode;

  if (delta > 0) {
    chipLevel = 'Critical';
    icon = <TbIcon name="TrendUp" color={theme.palette.error.main} />;
  } else if (delta < 0) {
    chipLevel = 'Success';
    icon = <TbIcon name="TrendDown" color={theme.palette.success.main} />;
  } else {
    chipLevel = 'Neutral';
    icon = <TbIcon name="TrendFlat" />;
  }

  const title = (
    <>
      {dimensionLabelId && (
        <>
          <FormattedMessage id={dimensionLabelId} />{' '}
        </>
      )}
      <FormattedMessage id={titleId} />
    </>
  );

  const chip = (
    <Chip
      size="small"
      sx={getChipSxStylingForLevel(chipLevel)}
      label={
        <div className="flex items-center gap-0.5">
          {icon}
          {Math.abs(delta)}
        </div>
      }
    />
  );

  return (
    <FilterableCountCard
      title={title}
      count={count}
      chip={chip}
      comparisonLabel={<FormattedMessage id="datepicker.options.comparison.previous.year.week" />}
      selected={selected}
      onClick={onClick}
      testId={testId}
    />
  );
}
